import { Builder } from '@builder.io/react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectSelectedCurrency } from '../../../../../../store/user';
import ReactSelect from 'react-select';
import Skeleton from 'react-loading-skeleton';
import CustomButton from '../../../../../../components/general/button';
import ConvertUSD from '../../../../../../utils/convertUSD';
import useHandleAddProduct from '../../../../../../utils/handleAddProduct';
import SelectCurrency from '../../../../../../components/general/selectCurrency';
import creditImg from '../../../../../../images/payment/credit-cards.png';
import ShowCurrencies from '../../../../../../utils/showCurrencies';
import { selectProducts, selectLastOrders } from '../../../../../../store/products';
import { BASKET_CACHE_KEY } from '../../../../../../utils/handleLocalStorage';

const AppealDetailsMainProduct = props => {
  /* ----------------------------- Start variables ---------------------------- */
  const { defaultProduct, goal = 1000000, appealsProducts = [], targetDate = '', suggestedPrices = [] } = props;
  const selectedCurrencyStore = useSelector(selectSelectedCurrency);
  const [addProduct] = useHandleAddProduct();
  const [daysLeft, setDaysLeft] = useState(0);
  const [selectedPrice, setSelectedPrice] = useState(suggestedPrices[2].price);
  const [selectAmount, setSelectAmount] = useState('');
  const allOrders = useSelector(state => selectLastOrders(state));
  const _allProducts = useSelector(state => selectProducts(state));
  const [mainProduct, setMainProduct] = useState();
  const [totalSale, setTotalSale] = useState(0);
  const [totalSupporters, setTotalSupporters] = useState(0);
  const [selectedGivingProducts, setSelectedGivingProducts] = useState([]);
  // let basketStatesFromLocalStorage = JSON.parse(localStorage.getItem(BASKET_CACHE_KEY));
  const [basketStatesFromLocalStorage, setBasketStatesFromLocalStorage] = useState(() => {
    return JSON.parse(localStorage.getItem(BASKET_CACHE_KEY)) || { products: [] };
  });

  /* ------------------------------ Start methods ----------------------------- */
  const handlePercentage = (raised, goal) => {
    return `${((Number(raised) / Number(goal)) * 100).toFixed(2)}%`;
  };
  /* ------------------------------- Start hooks ------------------------------ */
  useEffect(() => {
    const now = new Date();
    const target = new Date(targetDate);

    const diffInMs = target - now;
    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
    const safeDays = diffInDays > 0 ? diffInDays : 1;

    setDaysLeft(safeDays);
    // setShowTag(safeDays <= 10);
  }, [targetDate]);
  useEffect(() => {
    if (!_allProducts || !Object.keys(_allProducts).length) return;
    if (!allOrders) return;
    if (!defaultProduct?.creator) return; // ✅ Guard against undefined
    // Extract matching products & set main product if found
    const givingProducts = _allProducts.flatMap(item =>
      item.sub_categories.flatMap(sub =>
        sub.products.filter(product => {
          if (product.creator === defaultProduct?.creator) {
            setMainProduct(product);
          }
          return appealsProducts.includes(product.creator);
        }),
      ),
    );
    // let tempTotalGiving = 0;
    let tempSelectedGiving = [];
    let temp = [];
    givingProducts.map((item, index) => {
      basketStatesFromLocalStorage &&
        basketStatesFromLocalStorage.products.map(innerItem => {
          if (innerItem.product && innerItem.product.creator === item.creator) {
            item = Object.assign({}, item, {
              isAdded: true,
              quantity: innerItem.quantity,
            });
            // tempTotalGiving += (item.quantity || 1) * item[selectedCurrencyStore.toLowerCase()];
            tempSelectedGiving.push(item);
          }
          return innerItem;
        });
      temp[index] = item;
      return item;
    });
    // setSelectedGivingProducts(givingProducts);
    // console.log('before set giving===', tempSelectedGiving);
    setSelectedGivingProducts(tempSelectedGiving);
    // Normalize orders array
    const ordersArray = Array.isArray(allOrders) ? allOrders : allOrders?.data || [];
    if (ordersArray.length) {
      const updatedComingProducts = [...appealsProducts, defaultProduct.creator];
      // Filter orders for relevant creators
      const filteredOrders = ordersArray.filter(order => updatedComingProducts.includes(order.creator));
      // Calculate sums
      const saleSum = filteredOrders.reduce((sum, order) => sum + (order.total_sale || 0), 0);
      const supportersSum = filteredOrders.reduce((sum, order) => sum + (order.total_supporters || 0), 0);
      // Update state
      setTotalSale(saleSum);
      setTotalSupporters(supportersSum);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allOrders, _allProducts, appealsProducts, defaultProduct?.creator, basketStatesFromLocalStorage]);
  useEffect(() => {
    let handleBasketUpdated = event => {
      if (event.detail?.key === BASKET_CACHE_KEY) {
        const basket = JSON.parse(localStorage.getItem(BASKET_CACHE_KEY));
        setBasketStatesFromLocalStorage(basket);
      }
    };

    window.addEventListener('basketUpdated', handleBasketUpdated);
    return () => window.removeEventListener('basketUpdated', handleBasketUpdated);
  }, []);
  /* -------------------------------------------------------------------------- */

  return (
    <section className="w-full pt-4 md:pt-8">
      <h3 className={`w-full text-DarkerBlue text-2xl lg:text-3xl xl:text-4xl font-medium my-3 md:my-2 md:leading-none`}>
        {mainProduct ? defaultProduct.title || mainProduct.name : <Skeleton height={56} />}
      </h3>
      <div className="relative">
        {mainProduct ? <h4 className="text-stone-500">{defaultProduct.description || mainProduct.description}</h4> : <Skeleton count={4} />}
      </div>
      <div className={`w-full flex-col flex justify-center pt-2 md:pt-4`}>
        <div className="w-full text-lg md:text-2xl text-DarkerBlue font-bold flex items-end mb-2">
          <div className="text-DarkerBlue font-bold [&>div]:flex [&>div]:items-end [&>div>small]:mb-1">
            {totalSale && ShowCurrencies(selectedCurrencyStore, Math.round(totalSale), true)}
          </div>
          <span className="text-sm inline-block lg:w-auto text-stone-500 mx-1 font-medium mb-1">Raised of </span>
          <div className="text-DarkerBlue font-bold mr-1 [&>div]:flex [&>div]:items-end [&>span]:mb-1">
            {ShowCurrencies(selectedCurrencyStore, Math.round(ConvertUSD(selectedCurrencyStore, goal, false)), false)}
          </div>
          <span className="text-sm inline-block lg:w-auto font-medium mb-1">goal</span>
        </div>
        <div className="flex w-full h-2 bg-[#E3E3E3] mb-2">
          <div
            className={`bg-[#F60362]`}
            style={{
              width: `${handlePercentage(totalSale, ConvertUSD(selectedCurrencyStore, goal, false))}`,
            }}
          ></div>
        </div>
        <div className="flex w-full text-xs">
          <div className="text-DarkerBlue font-bold mr-0.5">{totalSupporters}</div>
          <span className="inline-block lg:w-auto mr-1">Supporters,</span>
          <div className="text-DarkerBlue font-bold mr-0.5">{daysLeft}</div>
          <span className="inline-block lg:w-auto">days left</span>
        </div>
      </div>
      <div className={`w-full grid grid-cols-3 gap-2 md:gap-3 my-2 md:my-4 md:max-w-[520px] lg:pr-3`}>
        {suggestedPrices.length &&
          suggestedPrices.map((item, index) => {
            return (
              <div
                key={`prices${index}`}
                onClick={() => {
                  setSelectedPrice(item.price);
                  selectAmount && setSelectAmount(item.price);
                }}
                className={`col-span-1w-full cursor-pointer transition-all duration-300 border border-LightBlue rounded-md flex justify-center items-center py-2 h-[42px] ${
                  selectedPrice === item.price ? 'bg-LightBlue text-white' : 'bg-white text-LightBlue'
                }`}
              >
                {ShowCurrencies(selectedCurrencyStore, item.price, true)}
              </div>
            );
          })}
        <>
          <SelectCurrency
            onChangeCurrency={e => {}}
            classNamePrefix="orphan_select- orphan_select--ghaza"
            className={`!w-full !text-sm max-h-[42px]- [&>div]:h-[42px]-`}
          />
          <div
            className={`col-span-2 sm:col-span-1 md:col-span-2 lg:col-span-1 relative h-[42px] flex border border-[#ccc] focus:ring-transparent focus:border-LightBlue rounded-[.375rem] w-full`}
          >
            <input
              value={selectAmount}
              name="amount"
              className="flex-1 text-[#777] w-full truncate p-2 text-sm focus:outline-none focus:ring-1 focus:ring-transparent !border-none rounded-[.375rem]"
              type="number"
              min={'0'}
              onChange={e => {
                const value = e.target.value;
                // Update the state only if the value is valid
                const regex = /^(?:[1-9]\d*)?$/;
                if (regex.test(value)) {
                  setSelectAmount(value);
                  setSelectedPrice(value ? parseInt(value, 10) : suggestedPrices[2].price); // Update selectedPrice with the custom value
                }
              }}
              placeholder="Other Amount"
            />
            {suggestedPrices.length > 0 && (
              <div className="absolute right-0 top-0 h-[42px]">
                <ReactSelect
                  defaultValue={{ value: selectAmount, label: selectAmount }}
                  onChange={selectedOption => {
                    setSelectAmount(selectedOption.value);
                    setSelectedPrice(selectedOption.value);
                  }}
                  classNamePrefix="price-select"
                  options={suggestedPrices.map(item => ({
                    value: item.price,
                    label: item.price,
                  }))}
                  isSearchable={false}
                  placeholder=""
                  isClearable={false} // Remove clear icon
                  className="notranslate max-h-[42px] [&>*]:!cursor-pointer !w-full [&>div]:!rounded-md !max-w-6"
                />
              </div>
            )}
          </div>
          <CustomButton
            {...(selectedGivingProducts.length
              ? { link: '/checkout' } // Navigate to '/checkout' if products exist
              : {
                  onClick: () =>
                    addProduct({
                      product: mainProduct,
                      currency: selectedCurrencyStore,
                      defaultPrice: selectedPrice,
                    }), // Add product if no products exist
                })}
            title={'Donate Now'}
            disabled={!mainProduct}
            type="button"
            className={`w-full col-span-3 sm:col-span-1 md:col-span-3 lg:col-span-1 !h-[42px]`}
          />
        </>
      </div>
      <div className="w-full rounded-md px-3 h-[38px] bg-[#80ceff] flex items-center justify-center sm:hidden">
        <img src={creditImg} alt="MATW" className="max-w-full h-auto max-h-[38px]" />
      </div>
    </section>
  );
};
Builder.registerComponent(AppealDetailsMainProduct, {
  name: 'AppealDetailsMainProduct',
  inputs: [
    {
      name: 'defaultProduct',
      type: 'object',
      defaultValue: {
        creator: '',
        label: '',
        description: '',
      },
      friendlyName: 'Main Product Info',
      subFields: [
        {
          name: 'creator',
          type: 'string',
          helperText: 'Enter product creator ID',
          required: true,
          hideFromUI: false,
        },
        {
          name: 'title',
          type: 'string',
          helperText: 'Display name for the product',
          required: false,
          hideFromUI: false,
          friendlyName: 'Product Title',
        },
        {
          name: 'description',
          type: 'string',
          helperText: 'Product reference value (usually product ID)',
          required: false,
          hideFromUI: false,
          friendlyName: 'Product Description',
        },
      ],
    },
    {
      name: 'goal',
      label: 'Goal',
      type: 'number',
      defaultValue: 1000000,
    },
    {
      name: 'targetDate',
      type: 'date',
      defaultValue: '',
      friendlyName: 'Target Date',
      required: true,
    },
    {
      name: 'suggestedPrices',
      type: 'array',
      subFields: [
        {
          name: 'price',
          type: 'number',
        },
      ],
    },
    {
      name: 'appealsProducts',
      type: 'array',
      subFields: [
        {
          name: 'creator',
          type: 'string',
        },
      ],
    },
  ],
});

export default AppealDetailsMainProduct;
